import {createContext} from 'react'

export const WebSocketContext = createContext({
    socket: null
})

